import TrailerPlayer from "./TrailerPlayer";

export default TrailerPlayer;
